// src/utils/userContext.ts
export const USER_ID_KEY = "userId";
export const USER_EMAIL_KEY = "userEmail";
export const USER_POSTCODE_KEY = "userPostcode";

export function getUserId(): number {
  const raw = localStorage.getItem(USER_ID_KEY);
  const n = Number(raw || "0");
  return Number.isFinite(n) ? n : 0;
}

export function setUserContext(userId: number, email?: string, postcode?: string) {
  if (userId > 0) localStorage.setItem(USER_ID_KEY, String(userId));
  if (email) localStorage.setItem(USER_EMAIL_KEY, email);
  if (postcode) localStorage.setItem(USER_POSTCODE_KEY, postcode);
}

export function clearUserContext() {
  localStorage.removeItem(USER_ID_KEY);
  // keep email/postcode if you want persistence; uncomment if not:
  // localStorage.removeItem(USER_EMAIL_KEY);
  // localStorage.removeItem(USER_POSTCODE_KEY);
}